import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import TerrainOutlinedIcon from '@mui/icons-material/TerrainOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum TrailSectionIds {
  general = 'general',
  specs = 'specs',
  location = 'location',
  map = 'map',
  weather = 'weather',
  integrations = 'integrations',
}

/**
 * @description Sections shared by the Trail detail page and edit form, in display order.
 */
export const trailSections: SectionDefinition[] = [
  {
    id: TrailSectionIds.general,
    title: 'General',
    description: 'Name, app link, description, and visibility.',
    icon: InfoOutlinedIcon,
  },
  {
    id: TrailSectionIds.specs,
    title: 'Trail Specs',
    description: 'Difficulty, surface, and size of the trail.',
    icon: TerrainOutlinedIcon,
  },
  {
    id: TrailSectionIds.location,
    title: 'Location',
    description: 'Address, trailhead coordinates, and parking.',
    icon: PlaceOutlinedIcon,
  },
  {
    id: TrailSectionIds.map,
    title: 'Map Data',
    description: 'OpenStreetMap relations or ways used to draw the trail on the map.',
    icon: MapOutlinedIcon,
  },
  {
    id: TrailSectionIds.weather,
    title: 'Weather & Algorithm',
    description: 'Weather sources and tuning for the status algorithm. Blank values inherit from the trail system.',
    icon: CloudOutlinedIcon,
  },
  {
    id: TrailSectionIds.integrations,
    title: 'Integrations',
    description: 'Sync this trail’s status to third-party services.',
    icon: HubOutlinedIcon,
  },
]
